export const defaultNavigation = [
  {
    title: "edX",
    links: [
      { title: "About", href: "https://www.edx.org/about-us" },
      { title: "edX For Business", href: "https://business.edx.org/" },
      { title: "Affiliates", href: "https://www.edx.org/affiliate-program" },
      { title: "Open edX", href: "http://open.edx.org" },
      { title: "2U Advisory Council", href: "http://www.edx.org/advisory-groups" },
      { title: "Careers", href: "https://www.edx.org/careers" },
      { title: "News", href: "https://press.edx.org" },
    ],
  },
  {
    title: "Connect",
    links: [
      { title: "Idea Hub", href: "https://www.edx.org/resources" },
      { title: "Contact Us", href: "https://courses.edx.org/support/contact_us" },
      { title: "Help Center", href: "https://help.edx.org/edxlearner" },
      { title: "Security", href: "https://www.edx.org/policy/security" },
      { title: "Media Kit", href: "https://www.edx.org/media-kit" },
    ],
  },
  {
    title: "Legal",
    links: [
      { title: "Terms of Service & Honor Code", href: "https://www.edx.org/edx-terms-service" },
      { title: "Privacy Policy", href: "https://www.edx.org/edx-privacy-policy" },
      { title: "Cookie Policy", href: "https://www.edx.org/edx-privacy-policy/cookies" },
      { title: "Accessibility Policy", href: "https://www.edx.org/accessibility" },
      { title: "Trademark Policy", href: "https://www.edx.org/trademarks" },
      { title: "Modern Slavery Statement", href: "https://www.edx.org/modern-slavery-statement" },
      { title: "Sitemap", href: "https://www.edx.org/sitemap" },
      { title: "Your Privacy Choices", href: "#", "data-target": "onetrust" },
    ],
  },
];
